<script>
  import { PayrollInvoiceData } from '@/utils/helpers/PayrollData'
  import { EmployeeResource, ClientResource, ProjectResource, AddressResource, CityResource, StateResource } from '@sigmacloud/sigma-client/dist/resources'
  import { reportMixins } from '@/Mixins/Reports'
  // import { pad } from '@/utils/helpers/StringsNumbers'
  import Autocomplete from '@/components/SigmaClientNew/Autocomplete.vue'
  import DateField from '@/components/InputComponents/DateField.vue'

  export default {
    name: 'ClientExport',
    components: {
      Autocomplete,
      DateField
    },
    mixins: [ reportMixins ],
    data () {
      return {
        payrollData: undefined,
        reportOptions: {
          transactionStatuses: [ 'posted', 'closed' ],
          accountQuickPick: 'all',
          type: 'unionV1',
          dates: 'datesAll',
          sort: 'account',
          status: 'all',
          format: 'csv',
          currencyFactor: undefined,
          report_currency_id: 1
        },
        allCodes: {},    // Show codes, e.g. accounts, series, locations, sets, etc.
        selectedCodes: {
          period_start: undefined,
          period_end: undefined,
          time_posted_start: undefined,
          time_posted_end: undefined,
          effective_date_start: undefined,
          effective_date_end: undefined,
          pay_period_start_date: undefined,
          pay_period_end_date: undefined,
          client_id: undefined,
          project_id: undefined,
          account_id: [],
          company_id: undefined,
          transaction_id: undefined,
          doc_number: '',
          currency_id: []
        },
        jasperSettings: {
          reportServer: 'https://jasper2.revolutiones.com:8443/jasperserver/rest_v2/reports/Revolution/Payroll/',
          reportName: 'pr_detail_edit_report'
        },
        vendors: undefined,
        transactionTypes: {     // Types of transactions and whether we need them or not
          'prs': { name: 'PRINV', include: true }
        },
        disableReportRun: false, // Disable run report button if false
        reportJson: undefined,
        prettyJson: undefined,
        showJson: false,
        reportNotif: undefined,
        collapseExpenses: false,
        loading: false
      }
    },

    computed: {
      resources () {
        return {
          EmployeeResource: EmployeeResource,
          ClientResource: ClientResource,
          ProjectResource: ProjectResource
        }
      },
      username () { return this.$store.getters.getUser.username },
      includedTypes () {
        return Object.values(this.transactionTypes).filter(types => types.include === true).map(type => type.name)
      },
      dateStart () {
        switch (this.reportOptions.dates) {
          case 'datesPeriod':
            return (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_start) || {}).start || '0000/00/00'

          case 'datesEffective':
            return this.selectedCodes.effective_date_start || '0000/00/00'

          case 'datesPosted':
            return this.selectedCodes.time_posted_start || '0000/00/00'

          default:
            return 'ALL'
        }
      },
      dateEnd () {
        switch (this.reportOptions.dates) {
          case 'datesPeriod':
            return (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_end) || {}).end || '9999/99/99'

          case 'datesEffective':
            return this.selectedCodes.effective_date_end || '9999/99/99'

          case 'datesPosted':
            return this.selectedCodes.time_posted_end || '9999/99/99'

          default:
            return 'ALL'
        }
      }
    },
    methods: {
      resetComponent () {
        this.reportJson = this.prettyJson = undefined
        for (const i in this.selectedCodes) {
          if (typeof this.selectedCodes[i] === 'object' && Array.isArray(this.selectedCodes[i])) this.selectedCodes[i] = []
          else if (typeof this.selectedCodes[i] === 'object') this.selectedCodes[i] = {}
          else this.selectedCodes[i] = undefined
        }
        this.$refs['client-autocomplete'].reset()
        this.$refs['project-autocomplete'].reset()
      },
      updateReportType (type) {
        this.reportOptions.type = type
      },
      updateReportDates (type) {
        this.selectedCodes.period_start = this.selectedCodes.period_end = this.selectedCodes.time_posted_start = this.selectedCodes.time_posted_end = this.selectedCodes.effective_date_start = this.selectedCodes.effective_date_end = undefined
      },
      includePrs ({target}) {
        this.transactionTypes.prs.include = target.checked
      },
      selectClient (resource) {
        this.selectedCodes.client_id = resource ? resource.attributes.id : undefined
      },
      selectProject (resource) {
        this.selectedCodes.project_id = resource ? resource.attributes.id : undefined
      },

      // Generates an export by employee
      async unionV1Export (payrollData) {
        if (!payrollData) return
        let results = []
        // get Employee SSNs

        await this.resources.EmployeeResource.all({ query: { id__in: payrollData.employeeIds.join(',') } })
        // const clientResource = await this.resources.ClientResource.detail(payrollData.clientId)
        const projectResource = await this.resources.ProjectResource.detail(payrollData.projectId)
        // payrollData.employeeIds)

        const empResources = EmployeeResource.getCachedAll() || []
        const addressResidenceIds = [ ...new Set(empResources.map((cached) => (cached && cached.resource.attributes) ? cached.resource.attributes.address_residence : null)) ]
        if (addressResidenceIds) {
          // await AddressResource.all({ query: { id__in: addressResidenceIds.join(',') }, resolveRelated: { managers: [ 'state', 'city' ] } })
          await AddressResource.all({ query: { id__in: addressResidenceIds.join(',') } })
          const cityIds = [ ...new Set((AddressResource.getCachedAll() || []).map((cached) => (cached && cached.resource.attributes) ? cached.resource.attributes.city : null)) ]
          const stateIds = [ ...new Set((AddressResource.getCachedAll() || []).map((cached) => (cached && cached.resource.attributes) ? cached.resource.attributes.state : null)) ]
          if (cityIds) {
            await CityResource.all({ query: { id__in: cityIds.join(',') } })
          }
          if (stateIds) {
            await StateResource.all({ query: { id__in: stateIds.join(',') } })
          }
        }

        // Header
        let csv = 'Client: ' + payrollData.projectName + '\n' +
          'PR ' + payrollData.payrollNumber + ' WE ' + new Date(payrollData.weekEndingTime).toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'}) + '\n' +
          payrollData.payrollNumber + '\n' + 'Total: ' + payrollData.totalInvoiceAmount + '\n\n'

        csv += 'Account, Series, Location, Set, FF1, Description, Amount\n'

        let clientInfo = {
          clientName: `"${payrollData.clientName}"`,
          contactName: `"${payrollData.contactName}"`,
          signatoryFein: projectResource.attributes.tin
          // projectName: `"${payrollData.projectName}"`
        }

        // Loop through each assignment
        for (const id in payrollData.assignmentsData) {
          const job = payrollData.assignmentsData[id]
          if (job.getTotalUnionBenefits() === '0.00') continue
          const empResource = ((EmployeeResource.getCached(job.employeeId) || {}).resource || {})
          const eeAddressId = empResource.attributes.address_residence
          const eeAddress = eeAddressId && AddressResource.getCached(eeAddressId) ? AddressResource.getCached(eeAddressId).resource : new AddressResource()
          /*
          const eeDirectDeposit = (EmployeeDirectDepositRuleResource.getCachedAll() || []).find((cached) =>
            cached && cached.resource.attributes && cached.resource.attributes.employee === job.employeeId && cached.resource.attributes.active === true
          )
          */
          await eeAddress.resolveRelated({ managers: [ 'state', 'city' ] })

          let output = {
            project: `"${job.projectName}"`,
            employee: `"${job.employeeName}"`,
            tin: empResource.attributes ? `"${empResource.attributes.tin}"` : job.tinLast4,
            dob: empResource.attributes ? empResource.attributes.birth_date : '',
            address1: eeAddress.attributes ? `"${eeAddress.attributes.line1}"` : '',
            address2: eeAddress.attributes ? `"${eeAddress.attributes.line2}"` : '',
            city: eeAddress.attributes ? `"${eeAddress.get('city.name')}"` : '',
            state: eeAddress.attributes ? `"${eeAddress.get('state.code')}"` : '',
            postal: eeAddress.attributes ? `"${eeAddress.attributes.postal}"` : '',
            local: `"${job.local}"`,
            payPeriodStartDate: payrollData.payPeriodStartDate,
            payPeriodEndDate: payrollData.payPeriodEndDate,
            workDays: job.getWorkDays() || 0,
            totalHours: job.getTotalHours() || 0,
            pensionableHours: job.getPensionableHours() || 0,
            scale: job.scaleRate || 0,
            grossPay: job.getTotalPay() || 0,
            pensionablePay: job.getPensionablePay() || 0,
            contributions: {},
            deductions: {}
          }

          for (const i in payrollData.unionFeeCodes) {
            const code = payrollData.unionFeeCodes[i]
            output.contributions[code] = job.getUnionBenefit(code) || 0
          }

          for (const i in payrollData.deductionCodes) {
            const code = payrollData.deductionCodes[i]
            output.deductions[code] = job.getDeduction(code) || 0
          }

          results.push(output)
        }

        // Make CSV
        csv = ''
        csv += Object.keys(clientInfo).join(',') + '\n'
        csv += Object.values(clientInfo).join(',') + '\n'

        if (!results || results.length === 0) return []
        csv += Object.keys(results[0]).join(',') + Object.values(payrollData.unionFeeCodes) + ',' + Object.values(payrollData.deductionCodes) + '\n'
        for (const i in results) {
          const record = results[i]
          const values = Object.values(record)
          // const length = record.length
          values.forEach((value) => {
            if (typeof value === 'object' && Array.isArray(value)) {
              csv += Object.values(value).join(',')
            } else if (typeof value === 'object') {
              // do nothing for now.
              csv += Object.values(value).join(',')
              // csv += value.join(',')
            } else {
              csv += value + ','
            }
          })
          csv += '\n'
        }

        this.reportOptions.format = 'csv'
        return csv
      },

      async generateReport () {
        this.disableReportRun = true
        let results

        // Get Payroll Data from sigma-query
        try {
          results = await this.getReportData('payrollinterface')
        } catch (error) {
          console.log('Error')
          console.log(error)
        } finally {
          this.disableReportRun = false
        }

        if (!results) {
          // console.log('No results')
          return false
        }
        const responses = results.data[0]
        // this.prettyJson = JSON.stringify(results.data[0], null, 2) // Help see why files fail

        if (!responses || !responses.length) {
          this.$notify({ title: 'No Union Data found', message: 'Please try with different reporting parameters.', type: 'error' })
          this.disableReportRun = false
          return
        }

        this.payrollData = new PayrollInvoiceData(responses)

        const fileExportType = this.reportOptions.type + 'Export'
        const fileExportData = await this[fileExportType](this.payrollData) || {}
        if (!fileExportData) {
          this.$notify({ title: 'No Union Data found', message: 'Please try with different reporting parameters.', type: 'error' })
          this.disableReportRun = false
          return
        }
        this.prettyJson = fileExportData
        this.createNotification('Success', `${this.payrollData.projectName} Export is Ready.`, 'success', false, this.reportOptions.format, `${this.payrollData.clientName}-${this.reportOptions.type}`)
        return fileExportData
      }
    },

    created () {
      // Load data to be used for validation
      this.disableReportRun = true
      this.getCompanyData()
        .then(response => {
          this.allCodes = Object.assign({}, response.data)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.disableReportRun = false
        })
    },

    beforeUnmount () {
      this.resetComponent()
    }
  }
</script>

<template>
  <div style="width: 100%;" v-loading.body="loading">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
          PAYROLL UNION EXPORT
        </el-row>
      </el-col>
      <el-col class="small">
          <a @click="showJson = ! showJson">.&nbsp;</a>
      </el-col>
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-tag v-if="disableReportRun" type="primary">
            <el-icon class="is-loading" style="margin: 0 6px;"><Loading/></el-icon>Running
          </el-tag>
          <el-button type="warning" @click="resetComponent">
            Reset
          </el-button>
          <el-button plain @click="generateReport" :disabled="disableReportRun">
            Run Export
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Report Options
        </el-row>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="2" class="right">
        Client
      </el-col>
      <el-col :span="4">
        <autocomplete
          name="client-autocomplete"
          ref="client-autocomplete"
          :resourceClass="resources.ClientResource"
          @select="selectClient($event)">
          <template v-slot:item="option">
            <p v-if="option.item.resource">
              {{ option.item.resource.attributes.name_reports }}
            </p>
            <p v-else-if="option.code">{{ option.code }}</p>
            <p v-else></p>
          </template>
        </autocomplete>
      </el-col>
      <el-col :span="2" class="right">
        Project
      </el-col>
      <el-col :span="4">
        <autocomplete
          name="project-autocomplete"
          ref="project-autocomplete"
          :resourceClass="resources.ProjectResource"
          @select="selectProject($event)">
          <template v-slot:item="option">
            <p v-if="option.item.resource">
              {{ option.item.resource.attributes.name }}
            </p>
            <p v-else-if="option.code">{{ option.code }}</p>
            <p v-else></p>
          </template>
        </autocomplete>
      </el-col>
      <el-col :span="2" class="right">
        PR #
      </el-col>
      <el-col :span="4">
        <el-input v-model="selectedCodes.doc_number" placeholder=""/>
      </el-col>
      <el-col :span="2" class="right">
        PR ID
      </el-col>
      <el-col :span="4">
        <el-input v-model="selectedCodes.transaction_id" placeholder=""/>
      </el-col>
    </el-row>

    <div class="m-top-100">
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="2"></el-col>
        <el-col :span="3">Pay Period Date Start</el-col>
        <el-col :span="2"></el-col>
        <el-col :span="3">Pay Period Date End</el-col>
        <!-- <el-col :span="1"></el-col>
        <el-col :span="3">Pay Code</el-col> -->
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="2"></el-col>
        <el-col :span="3">
          <DateField v-model="selectedCodes.pay_period_start_date" />
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="3">
          <DateField v-model="selectedCodes.pay_period_end_date" />
        </el-col>
        <!-- <el-col :span="1"></el-col>
        <el-col :span="3">
          <autocomplete
            name="paycode-autocomplete"
            ref="paycode-autocomplete"
            :resourceClass="resources.PayCodeResource"
            @select="selectPaycode($event)">
            <template v-slot:item="option">
              <p v-if="option.item.resource">
                {{ option.item.resource.attributes.name }}
              </p>
              <p v-else>{{ option.code }}</p>
            </template>
          </autocomplete>
        </el-col> -->
      </el-row>
    </div>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Format
      </el-col>
      <el-col :span="21">
        <el-radio-group v-model="reportOptions.type" @change="updateReportType">
          <el-radio-button value="unionV1">Union Spreadsheet</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>

    <el-row v-if="showJson">
      <el-col>
        <textarea id="output" style="width: 100%; height: 500px; font-family: 'Courier New'" v-model="prettyJson"></textarea>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  .m-top-20 { margin-top: 20px; }
  .m-right-20 { margin-right: 20px; }
</style>
<style>
  .el-select { display: block; }
  .el-transfer-panel { width:36%; max-width: 350px }
  .el-transfer-panel__body { min-height: 400px }
  .el-transfer-panel__list { min-height: 360px }
  /* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>
